import { $POST } from './commonRequest';
import useSWRMutation from 'swr/mutation';
import instance from './request';
import { identityId } from '@/env';

export interface INodes {
  oss: string[];
  rest: string[];
  ws: string[];
}

let nodeList: INodes = {
  oss: [],
  rest: [],
  ws: [],
};

let isCached = false;

export const useNodes = () => {
  const { isMutating, trigger } = useSWRMutation('/trans/nodes', async () => {
    if (isCached) {
      return nodeList;
    }

    const resp = await $POST<INodes>(`/miner-api/trans/nodes`, {
      roleType: 0,
      source: 1,
      identityID: identityId,
    });
    nodeList = resp.data || nodeList;

    const baseUrl = resp.data?.rest?.[0];

    instance.interceptors.request.use((config) => {
      config.baseURL = baseUrl;
      return config;
    });

    isCached = true;
    return nodeList;
  });

  return {
    nodes: nodeList,
    loading: isMutating,
    getNodes: trigger,
  };
};
